module.exports = __webpack_public_path__ + "static/media/KC.ed72b641.svg";